import React from 'react'
import { Link } from 'react-router-dom'

const RrdLink = (props) => {
    const {to, textColor, children} = props;

    return (
        <Link to={to} style={{textDecoration:'none', color:`${textColor}`}} >
            {children}
        </Link>
    )
}

export default RrdLink